export default "__VITE_ASSET__6XKwK0YF__"